document.addEventListener('DOMContentLoaded', function () {
    // Untuk tiap segment
    document.querySelectorAll('.faq-segment__list').forEach(function (segmentList) {
        // Ambil semua details di dalam segment
        const items = segmentList.querySelectorAll('.faq-segment__item');
        items.forEach(function (details) {
            details.addEventListener('toggle', function () {
                // Jika baru saja dibuka
                if (details.open) {
                    // Tutup semua selain yang ini
                    items.forEach(function (el) {
                        if (el !== details && el.open) {
                            el.open = false;
                        }
                    });
                }
            });
        });
    });
});
